export default __webpack_public_path__ + "static/media/logo.e7bfcf47.svg";